import { Page } from '@/core/architecture'

import { MailRegisterTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MailRegister Page
 * Implemented as a practical sample.
 */
export const MailRegister: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <MailRegisterTemplate
      state={state}
      onSubmitMailRegister={actions.sendVerificationMail}
      onLogout={actions.onLogout}
    />
  )
}
